import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import { handleResponseErr } from 'utils/apiHelperUtils'
import * as actions from './actions'
import { Department } from './types'

type State = {
  employees_department: {
    avatar_thumb: string
    code: number
    id: number
    jobTitle: string
    name: string
  }[]
  fetching: boolean
  hierarchical_departments: Department[]
  list_departments: Department[]
}

export const initialState: State = {
  fetching: false,
  hierarchical_departments: [],
  list_departments: [],
  employees_department: [],
}

export default function reducer(state = initialState, action: Action): State {
  switch (action.type) {
    case actions.HIERARCHICAL_DEPARTMENTS_NEW_LOAD_PENDING:
    case actions.LIST_DEPARTMENTS_LOAD_PENDING:
    case actions.DEPARTMENTS_POST_PENDING:
    case actions.DEPARTMENTS_PUT_PENDING:
    case actions.DEPARTMENTS_DELETE_PENDING:
      return {
        ...state,
        fetching: true,
      }

    case actions.EMPLOYEES_DEPARTMENT_LOAD_PENDING:
      return {
        ...state,
        fetching: true,
        employees_department: [],
      }

    case actions.HIERARCHICAL_DEPARTMENTS_NEW_LOAD_FULFILLED:
      return {
        ...state,
        hierarchical_departments: action.payload.data.data.departments,
        fetching: false,
      }

    case actions.LIST_DEPARTMENTS_LOAD_FULFILLED:
      return {
        ...state,
        list_departments: action.payload.data.data.departments,
        fetching: false,
      }

    case actions.EMPLOYEES_DEPARTMENT_LOAD_FULFILLED:
      return {
        ...state,
        employees_department: action.payload.data.data.employees,
        fetching: false,
      }

    case actions.DEPARTMENTS_POST_FULFILLED:
    case actions.DEPARTMENTS_PUT_FULFILLED:
    case actions.DEPARTMENTS_DELETE_FULFILLED:
    case actions.ASSIGN_EMPLOYEES_PUT_FULFILLED:
      Toastr.success(action.payload.data.message)
      return {
        ...state,
        ...action.payload.data.data,
        fetching: false,
      }

    case actions.HIERARCHICAL_DEPARTMENTS_NEW_LOAD_REJECTED:
    case actions.LIST_DEPARTMENTS_LOAD_REJECTED:
    case actions.DEPARTMENTS_POST_REJECTED:
    case actions.DEPARTMENTS_PUT_REJECTED:
    case actions.DEPARTMENTS_DELETE_REJECTED:
    case actions.EMPLOYEES_DEPARTMENT_LOAD_REJECTED:
    case actions.ASSIGN_EMPLOYEES_PUT_REJECTED:
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
      }
    default:
      return state
  }
}
